import React from 'react';
import { View } from '@react-pdf/renderer';
import { Entente } from '../../../../../../../common/src/entities';
import PriceTable from './PriceTablePDF';
import DetailsActiviteEntentePDF from './DetailsActiviteEntentePDF';
import HoraireEntentePDF from './HoraireEntentePDF';

// Visibilité Client
export default function ReservationContent({ entente }: { entente: Entente }) {
    const copieActiviteEntente = entente.activiteEntentes.filter(
        (activiteEntente) => activiteEntente.activite.typeActivite.name != 'Autobus',
    );

    const activiteEntenteBus = entente.activiteEntentes.filter(
        (activiteEntente) => activiteEntente.activite.typeActivite.name == 'Autobus',
    );

    return (
        <>
            <View wrap={false}>
                <HoraireEntentePDF horaireEntente={entente.horaire} />
            </View>
            {copieActiviteEntente.map((activiteEntente) => (
                <View wrap={false}>
                    <DetailsActiviteEntentePDF
                        activiteEntente={activiteEntente}
                        entente={entente}
                        activiteEntenteBus={activiteEntenteBus}
                        type_visibilite={'client'}
                    />
                </View>
            ))}
            <View wrap={false}>
                <PriceTable entente={entente} isFacture={false} />
            </View>
        </>
    );
}
